<template>
  <div>
    <Header
      :title="$t('users.userCreate').toString()"
      :show-back-button="true"
      :items="headerButtons"
      @back="$router.push({ name: 'projectSettingsUsers' })"
      @save="submit"
    />
    <div class="card card-custom">
      <div class="card-body">
        <FormHelper
          ref="form"
          v-model="user"
          :form="baseDataForm"
          :config="baseDataFormConfig"
        />
        <FormHelper
          ref="form"
          v-model="user"
          :form="profileForm"
          :config="profileFormConfig"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Users from "@/components/Settings/Users/users";
import FormHelper from "@/components/Tools/FormHelper/FormHelper.vue";
import Header from "@/components/Tools/Header/Header.vue";
import {
  addEventToLoadingQueue,
  removeEventFromLoadingQueue
} from "@/composables/useLoadingQueue";

export default {
  name: "ProjectUsersCreate",
  components: {
    Header,
    FormHelper
  },
  data() {
    return {
      headerButtons: [
        {
          type: "button",
          title: this.$t("general.save"),
          emit: "save"
        }
      ],
      baseDataFormConfig: {
        title: this.$t("users.baseData"),
        snippetPrefix: "user",
        enableVariables: false
      },
      baseDataForm: [
        {
          label: this.$t("users.salutation"),
          name: "salutation",
          type: "text",
          disableReturnType: true,
          placeholder: this.$t("users.enterSalutation"),
          validations: {
            minLength: 2
          }
        },
        {
          label: this.$t("users.title"),
          name: "title",
          type: "text",
          disableReturnType: true,
          placeholder: this.$t("users.enterTitle"),
          validations: {
            minLength: 2
          }
        },
        {
          label: this.$t("users.firstName"),
          name: "firstname",
          type: "text",
          disableReturnType: true,
          placeholder: this.$t("users.enterFirstName"),
          validations: {
            required: true,
            minLength: 2
          }
        },
        {
          label: this.$t("users.lastName"),
          name: "lastname",
          type: "text",
          disableReturnType: true,
          placeholder: this.$t("users.enterLastName"),
          validations: {
            required: true,
            minLength: 2
          }
        },
        {
          label: this.$t("users.email"),
          name: "email",
          type: "text",
          disableReturnType: true,
          placeholder: this.$t("users.enterEmail"),
          validations: {
            required: true,
            minLength: 2
          }
        },
        {
          label: this.$t("general.active"),
          name: "active",
          type: "checkbox"
        },
        {
          label: this.$t("users.admin"),
          name: "is_admin",
          type: "checkbox"
        }
      ],
      profileFormConfig: {
        title: this.$t("users.profile"),
        snippetPrefix: "user",
        enableVariables: false
      },
      profileForm: [
        {
          label: this.$t("users.password"),
          name: "password",
          type: "password",
          placeholder: this.$t("users.enterPassword"),
          disableReturnType: true,
          validations: {
            minLength: 2
          }
        },
        {
          label: this.$t("users.passwordConfirmation"),
          name: "passwordConfirmation",
          type: "password",
          placeholder: this.$t("users.enterPasswordConfirmation"),
          disableReturnType: true,
          validations: {
            minLength: 2
          }
        }
      ],
      user: {
        core_data: {
          salutation: "",
          title: "",
          firstname: "",
          lastname: ""
        },
        email: "",
        active: true,
        salutation: "",
        title: "",
        firstname: "",
        lastname: ""
      },
      currentUsers: []
    };
  },
  methods: {
    submit() {
      addEventToLoadingQueue({ key: "saveUser" });
      // Set necessary user data
      this.user.name = this.user.firstname + " " + this.user.lastname;
      this.user.core_data.salutation = this.user.salutation;
      this.user.core_data.title = this.user.title;
      this.user.core_data.firstname = this.user.firstname;
      this.user.core_data.lastname = this.user.lastname;

      Users.store(this.user)
        .then(() => {
          removeEventFromLoadingQueue({
            key: "saveUser",
            type: "success",
            prefix: "users",
            name: "userCreated"
          });
          this.$router.push({ name: "projectSettingsUsers" });
        })
        .catch(error => {
          this.$error(error);
        });
    }
  }
};
</script>
